<script>
    import { tour } from '../tour'
    import { fly } from 'svelte/transition';

    export let showingTooltip = false;
    export let text;
    export let position;
    
    import UA from 'ua-parser-js';
    const ua = new UA();
    let isMobile = ua.getResult().device['type'] == 'mobile';

    let flySettings = { duration: 500 }

           if(position == 'left'){      flySettings.x = -100;
    } else if(position == 'right'){     flySettings.x = 100;
    } else if(position == 'top'){       flySettings.y = -100;
    } else if(position == 'bottom'){    flySettings.y = 100; }
</script>

<!-- /*____________ Markup ____________*/ -->
{#if showingTooltip && !isMobile}
<div transition:fly={flySettings} class="tooltip no-select {position}">{text}</div>
{/if}

<!-- /*____________ CSS ____________*/ -->
<style>
.tooltip {
    background: #000;
    border-radius: 8px;
    padding: 10px;
    color: #fff;
    display: inline-block;
    font-family: 'Raleway', sans-serif;
    font-size: 0.9rem;
    position: absolute;
    white-space: nowrap;
}

.right { left: 100%; margin-left: 15px; }
.left { right: 100%; margin-right: 15px; }
.bottom { top: 100%; margin-top: 15px; }
.top { bottom: 100%; margin-bottom: 15px; }

.tooltip::after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
}


.bottom.tooltip::after {
    border-width: 10px 8px 10px 8px;
    border-color: transparent transparent #000 transparent; /* arrow  up */
    top: -20px;
    /* left: 10px; */
    left: 0;
    right: 0;
    margin: auto;
}

.top.tooltip::after {
    border-width: 10px 8px 10px 8px;
    border-color: #000 transparent transparent transparent; /* arrow  down */
    bottom: -20px;
    /* left: 10px; */
    left: 0;
    right: 0;
    margin: auto;
}

.right.tooltip::after {
    border-width: 8px 10px 8px 10px;
    border-color: transparent #000 transparent transparent; /* arrow left */
    left: -20px;
}

.left.tooltip::after {
    border-width: 8px 10px 8px 10px;
    border-color: transparent transparent transparent #000;  /* arrow right */
    right: -20px;
}
</style>